import "react-phone-number-input/style.css";
import { useEffect } from "react";
import {
  Box,
  Button,
  FormControl,
  FormHelperText,
  Stack,
  Typography,
} from "@mui/material";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import TextInputField from "./textInputField";
import { Controller, useForm } from "react-hook-form";
import PhoneInput from "react-phone-number-input";
import { retrieveData, storeData } from "../helper/helper";
import Note from "./note";

export default function PersonalInformationForm({
  onStepDecrement,
  getStepThreeData,
}) {
  const defaultValues = {
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
  };
  const phoneRegExp = /^(?:\+44\d{10}|0\d{10})$/;
  const Schema = yup.object().shape({
    firstName: yup.string().required("Required Field"),
    lastName: yup.string().required("Required Field"),
    email: yup
      .string()
      .email("Email must be a valid email")
      .required("Required Field"),
    phoneNumber: yup
      .string()
      .matches(phoneRegExp, "Invalid phone number")
      .required("Required Field"),
  });
  const {
    handleSubmit,
    control,
    formState: { errors, isValid },
    reset,
  } = useForm({
    defaultValues: defaultValues,
    mode: "onChange",
    resolver: yupResolver(Schema),
  });
  const onSubmit = (data) => {
    if (data) {
      storeData("stepThreeData", data);
      getStepThreeData(data);
    }
  };

  useEffect(() => {
    const stepThreeData = retrieveData("stepThreeData");
    if (stepThreeData) {
      reset({ ...stepThreeData });
    }
  }, []);
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    scrollToTop();
  }, []);

  return (
    <div>
      <form>
        <Box sx={{ mt: 3 }}>
          <Typography fontWeight={500} color={"primary"}>
            First Name<sup>*</sup>
          </Typography>
          <TextInputField
            controller={{
              control: control,
              errors: errors.firstName,
            }}
            name={"firstName"}
            required
          />
        </Box>
        <Box sx={{ mt: 3 }}>
          <Typography fontWeight={500} color={"primary"}>
            Last Name<sup>*</sup>
          </Typography>
          <TextInputField
            controller={{
              control: control,
              errors: errors.lastName,
            }}
            name={"lastName"}
            required
          />
        </Box>

        <Box sx={{ mt: 3 }}>
          <Typography fontWeight={500} color={"primary"}>
            Email<sup>*</sup>
          </Typography>
          <Typography variant="caption" color={"#757575"}>
            ⓘ We'll send your booking confirmation via email
          </Typography>
          <TextInputField
            controller={{
              control: control,
              errors: errors.email,
            }}
            name={"email"}
            required
            type="email"
          />
        </Box>
        <Box sx={{ mt: 3 }}>
          <Typography fontWeight={500} color={"primary"}>
            Phone number<sup>*</sup>
          </Typography>
           <Typography variant="caption" color={"#757575"}>
            ⓘ We'll provide your booking updates via phone
          </Typography>
          <FormControl fullWidth sx={{ mt: 1, mb: 2 }}>
            <Controller
              name={"phoneNumber"}
              control={control}
              rules={{ required: true }}
              render={({ field: { value, onChange, onBlur } }) => (
                <PhoneInput
                  defaultCountry="GB"
                  value={value}
                  onChange={onChange}
                />
              )}
            />
            {errors.phoneNumber && (
              <FormHelperText sx={{ color: "error.main" }}>
                {errors.phoneNumber.message}
              </FormHelperText>
            )}
          </FormControl>
        </Box>
        <Stack
          mt={3}
          direction={"row"}
          justifyContent={"space-between"}
          alignItems={"center"}
        >
          <Button size="small" variant="outlined" onClick={onStepDecrement}>
            Back
          </Button>
          <Button
            size="small"
            variant="contained"
            type="submit"
            disabled={!isValid}
            onClick={handleSubmit(onSubmit)}
          >
            Review
          </Button>
        </Stack>
        <Note />
      </form>
    </div>
  );
}
